// Angular
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const ZIP_CODE_CUSTOM_ERRORS = [
  { error: 'invalidZipCode', message: 'Valid zip code (e.g. 12345 or 12345-6789)' },
];

/**
 * A custom validator to validate the zip code.
 *
 * @returns A ValidationErrors object if the zip code is invalid, otherwise null.
 */
export function zipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      // If the control value is empty return null because there's no zip code to validate.
      return null;
    }

    // Define the regex for a valid zip code.
    const zipCodeRegex = /^\d{5}(-\d{4})?$|^\d{9}$/;

    // If the control value does not match the regex for a valid zip code, return an error.
    if (!zipCodeRegex.test(control.value)) {
      return { 'invalidZipCode': true };
    }

    // Otherwise return null because the zip code is valid.
    return null;
  };
}
